<template>
  <video
    autoplay
    loop
    preload="auto"
    muted
  >
    <source :src="webmSource" type="video/webm">
    <p v-if="content">{{ content }}</p>
  </video>
</template>

<script>
export default {
  props: {
    webmSource: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
}
</script>
